import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { PromoCampaignItem } from '@shared/models/DigitalPromo';
import { TrackingService } from '@shared/services/tracking.service';

@Component({
  selector: 'app-promo-banner',
  templateUrl: './promo-banner.component.html',
  styleUrls: ['./promo-banner.component.scss'],
  standalone: false
})
export class PromoBannerComponent implements OnInit {
  @Input() currency: string;
  @Input() language: string;
  @Input() campaign: PromoCampaignItem;

  highestAmount: number;

  constructor(
    private router: Router,
    private trackingService: TrackingService
  ) {}

  ngOnInit(): void {
    this.highestAmount = Math.max(...this.campaign.promotions.map((o) => o.attributes.value));
  }

  goToPromo() {
    void this.router.navigate([`/promo-campaign/${this.campaign.id}`]);
  }
}
